<template>
 <div id="search">
    <div class="serrchwrap">
	  <div class="imgback" @click="returnback">
	  	<div class="imgwrag">
		 	<img src="../../../static/images/back_arrow.png"/>
		</div>
	  </div>
	  <div class="page-search" v-on:keyup.13="submit">
		   <mt-search v-model="value" autofocus placeholder="搜索"  @input="search(value)"> 
		   	 <listData :searchData="searchData" v-on:refHistoryItems="setHistoryItems"></listData>
		   </mt-search>
	  </div>
    </div>
  	<div v-show="value==''">
	   <p class="font-size9 line-height30 bgfff plr12 colorff8920 border-bottom-line pt6">热门搜索</p>
	   <div class="bgcontent">
	   	<ul class="hot-search">
	   		<li v-for="item in hotlist" :class="{colorff8920: item.isLight==1}" @click="queryData(item.forName)">{{item.forName}}</li>
	   	</ul>
	   </div>
	   <div v-if="historyItem!=null">
	   	<p class="colorBox"></p>
		   <p class="font-size9 mt5 line-height30 bgfff plr12 colorff8920 border-bottom-line pt6">
		   	搜索历史
		   <a href="javascript:void(0)" class="float-right font-size7 color999" @click="clearHistory">清除历史</a>
		   </p>
		   <ul class="h-records">
		   	<li v-for="item in historyItem" @click="queryData(item)"><a href="javascript:void(0)">{{item}}</a></li>
		   </ul>
	   </div>
   	</div>
   <!--搜索无结果-->
   <div class="text-center mt80 color333 font-size9 letter-spacing2" v-show="value!=''&&searchData.length==0">未找到<span class="colorff8920">"{{value}}"</span>的相关内容</div>
 </div>
</template>

<script>
 import { Toast } from 'mint-ui'
 import listData from '@/components/searchList'
 export default{
 	name: 'page-search',
 	components:{
			listData,
		},
		data(){
			return{
			   hotlist:[],
			   value:"", 
			   historyItem:JSON.parse(localStorage.getItem('historyList')),
			   searchData:[]
			}
		},
		created:function(){
			this.showHotList();
	    },
	    methods: {
	      returnback(){
	      	this.$router.back();
	      },
	      showHotList(){
	      	   this.$http.post(this.URL_PREFIX+"/foregmod/findKeywordApi.net")
		  	   .then((res) =>{
		  	    this.hotlist=res.data.rows;
		  	  });
	      },
	      search(value){
	        this.searchDate(value);
          },
          submit(){
			 this.searchDate(value);
			 this.setHistoryItems(this.value);
		  },
		  searchDate(value){
		  	this.$http.post(this.URL_PREFIX+"/category/searchCategory.net",{cateName:value})
		  	   .then((res) =>{
//		  	   	console.log('打印搜索列表');
//		  	   	console.log(res.data.rows);
		  	   	this.searchData=res.data.rows;
		  	});
		  },
		  queryData(val){
		  	this.value=val;
		  },
          setHistoryItems(keyword) {  
		    keyword = keyword.trim();  
		    let { historyItems } = localStorage;  
		    if(keyword!=""){
			    if(historyItems === undefined) {  
			      localStorage.historyItems = keyword;  
			    }else{ 
			      const onlyItem = historyItems.split('|').filter(e => e != keyword);  
			      if (onlyItem.length < 10&&onlyItem.length!=0){
			      	historyItems = keyword + '|' + onlyItem.join('|');
			      }else{
			      	historyItems = keyword + '|' + onlyItem.join('|');
			        historyItems=historyItems.substring(0, historyItems.lastIndexOf('|'));
			      }
			        localStorage.historyItems = historyItems;  
			    }
			       var historyList=localStorage.getItem('historyItems').split('|');
			       var obj=JSON.stringify(historyList);
			       localStorage.setItem("historyList",obj);
			       this.historyItem=JSON.parse(localStorage.getItem('historyList'));
		    }
		  }, 
		  clearHistory() {  
		  	 Toast("已清除");
			 localStorage.removeItem('historyItems');   
			 localStorage.removeItem("historyList");
			 this.historyItem=null;
		  }, 
	    }
	}
</script>

<style scoped="scoped">
.bgcontent{width: 100%;background: #fff;display: inline-block;overflow: hidden;}
.hot-search,.h-records{padding: 12px 20px 5px 0;overflow: hidden;}
.hot-search li,.h-records li a{float: left;margin: 0 0 10px 20px;}
.hot-search li{color: #333;font-size: 0.8rem;}
.hot-search li.colorff8920{color: #ff8920;}
.h-records li a{color: #333;font-size: 0.8rem;border:1px solid #e0e0e0;text-align: center;border-radius: 8px;-webkit-border-radius:8px; height: 26px;line-height: 26px;padding: 0px 16px;}
.h-records{padding: 12px 8px 5px 0;background-color: #fff;}
.h-records li a{margin: 0 0 10px 12px;background: #fff;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.h-records li a.active{background-color: #ff8920;color: #fff;border: none;}
.serrchwrap{display: flex;}
.imgback{width:40px;background: #ff8920;}
.page-search{flex: 1;}
.imgback .imgwrag{width: 37px; margin-top: 7px;margin-left: 3px;}
.imgback .imgwrag img{width: 100%;}
</style>


// WEBPACK FOOTER //
// src/views/Search/index.vue